import { useSelector } from 'react-redux';

import { FIRST_PAYMENT_DAY, formatUtils } from '@makemydeal/dr-dash-components';
import * as paymentSelectors from '@makemydeal/dr-dash-store/selectors/payment';
import { shortDateString } from '@makemydeal/dr-dash-store/utils/dateFormatters';

import { NOT_AVAILABLE } from '../../../../constants';

export const useFirstPaymentDateField = () => {
    const firstPaymentDate = useSelector(paymentSelectors.getFirstPaymentDateBySelectedTerm);

    return {
        label: FIRST_PAYMENT_DAY,
        value: !firstPaymentDate
            ? NOT_AVAILABLE
            : shortDateString(
                  // Currently, Payment service does not return time zone info with first payment date.
                  // Considering EST for now,

                  // TODO: Update it when PS start sending timezone info with first payment date.
                  // Or PS starts giving firstPaymentDate as per the input contractDate
                  new Date(formatUtils.mergeDateWithCurrentESTTime(firstPaymentDate, 'yyyy-MM-dd') as any)
              )
    };
};
